'use client';

import { Link } from '@coolblue-development/freddy';
import selectContinueShoppingTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/selectContinueShoppingTrigger';
import { ArrowLeft } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import type { MouseEvent } from 'react';

type Props = {
  fallbackUrl?: string;
};

export default function ContinueShoppingLink({ fallbackUrl }: Props) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();

  function onClick(event: MouseEvent<HTMLAnchorElement>) {
    trackEvent(selectContinueShoppingTrigger());

    if (history.length > 1) {
      event.preventDefault();
      history.back();
    }
  }

  return (
    <Link startIcon={<ArrowLeft />} onClick={onClick} href={fallbackUrl}>
      {t('addToCart.continueShopping')}
    </Link>
  );
}
